(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["example-sw-custom-footer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var el = document.getElementById('footer-year--{{ section.id }}');
    if (el) { el.textContent = new Date().getFullYear(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["example-sw-faq"] && !Shopify.designMode) return;
  try {
    
  /* Accessible accordion behaviour - single global handler to support multiple FAQ sections */
  if (typeof window.swFaqInitialized === 'undefined') {
    window.swFaqInitialized = true;

    $(function () {
      // Use event delegation once on document level
      $(document).on('click', '.sw-faq-question', function () {
        var $btn = $(this);
        var $item = $btn.closest('.sw-faq-item');
        var $section = $btn.closest('[data-faq-section]'); // scoped by unique section.id
        var $answer = $item.find('.sw-faq-answer');
        var isOpen = $item.hasClass('active');

        /* Toggle clicked item */
        $btn.attr('aria-expanded', !isOpen);
        $answer.stop(true, true).slideToggle(300);
        $item.toggleClass('active');

        /* Close siblings inside the same section only */
        $section.find('.sw-faq-item').not($item).each(function () {
          $(this)
            .removeClass('active')
            .find('.sw-faq-answer').stop(true, true).slideUp(300)
            .end()
            .find('.sw-faq-question').attr('aria-expanded', false);
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-custom-footer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var el = document.getElementById('footer-year--{{ section.id }}');
    if (el) { el.textContent = new Date().getFullYear(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-faq"] && !Shopify.designMode) return;
  try {
    
  /* Accessible accordion behaviour - single global handler to support multiple FAQ sections */
  if (typeof window.swFaqInitialized === 'undefined') {
    window.swFaqInitialized = true;

    $(function () {
      // Use event delegation once on document level
      $(document).on('click', '.sw-faq-question', function () {
        var $btn = $(this);
        var $item = $btn.closest('.sw-faq-item');
        var $section = $btn.closest('[data-faq-section]'); // scoped by unique section.id
        var $answer = $item.find('.sw-faq-answer');
        var isOpen = $item.hasClass('active');

        /* Toggle clicked item */
        $btn.attr('aria-expanded', !isOpen);
        $answer.stop(true, true).slideToggle(300);
        $item.toggleClass('active');

        /* Close siblings inside the same section only */
        $section.find('.sw-faq-item').not($item).each(function () {
          $(this)
            .removeClass('active')
            .find('.sw-faq-answer').stop(true, true).slideUp(300)
            .end()
            .find('.sw-faq-question').attr('aria-expanded', false);
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
